import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Media, { MediaElement } from '@/components/base/media'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type ArchiveCardProps = HTMLAttributes<HTMLElement> & {
  title: string
  paragraph: string
  media: MediaElement
  link: WPLink
}

const ArchiveCard = ({
  media,
  title,
  paragraph,
  link,
  className,
  ...props
}: ArchiveCardProps) => {
  return (
    <div className={cn('relative', className)} {...props}>
      <div className="grid gap-y-[3.2rem]">
        <div className="relative aspect-square bg-havana">
          <Media fill fit="cover" {...media} />
        </div>

        <div className="grid gap-y-[1.6rem]">
          {title ? (
            <Typography variant="h5" component="h5" className="font-timesnow">
              {title}
            </Typography>
          ) : null}

          {paragraph ? (
            <Typography
              variant="body"
              paragraph
              className="font-gillsans font-light"
            >
              {paragraph}
            </Typography>
          ) : null}

          {link && link.url ? (
            <Link
              href={link.url}
              target={link.target}
              className="after:absolute after:left-0 after:top-0 after:h-full after:w-full"
            >
              <span className="sr-only">{title}</span>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ArchiveCard
